var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { gqlSdk } from '@cta-portal/webapp-common/lib/api/client';
import { MpcWalletTransactionStatus } from '@cta-portal/webapp-common/lib/api/schema';
import { x } from '@imtbl/sdk';
import { ethers } from 'ethers';
import { useContext } from 'react';
import { CurrencyContext } from '../../context/currency';
import { UserContext } from '../../context/user';
import { appEnv } from '../../env';
import { WalletConnectionType } from '../../types/blockchain';
import { sleep } from '../../utils/async';
import { ethValidChainId } from '../../utils/blockchain';
import { decryptString, deriveSymmetricKey } from '../../utils/mpc';
import { usePendingTransfer } from '../blockchain/use-pending-transfer';
var LOCAL_STORAGE_STARK_KEY_MAP = 'starkware-account-map';
export function useImxActions() {
    var _a = useContext(UserContext), user = _a.user, fees = _a.fees, _b = _a.magicLinkContext, magic = _b.magic, loginWithMagicLink = _b.loginWithMagicLink;
    var imxClient = useContext(CurrencyContext).imxClient;
    var initPendingTransfer = usePendingTransfer().initPendingTransfer;
    function tokenAmountHelper(tokenAddress, amount) {
        if (tokenAddress === '')
            return {
                type: 'ETH',
                amount: amount,
            };
        return {
            type: 'ERC20',
            tokenAddress: tokenAddress,
            amount: amount,
        };
    }
    function getMagicLinkSigner(wallet) {
        return __awaiter(this, void 0, void 0, function () {
            var loginRequired, isLoggedIn, metadata, provider, ethSigner;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!wallet.email)
                            return [2 /*return*/];
                        loginRequired = false;
                        return [4 /*yield*/, magic.user.isLoggedIn()];
                    case 1:
                        isLoggedIn = (_b.sent());
                        if (!isLoggedIn) return [3 /*break*/, 5];
                        return [4 /*yield*/, magic.user.getInfo()];
                    case 2:
                        metadata = _b.sent();
                        if (!(!(metadata === null || metadata === void 0 ? void 0 : metadata.publicAddress) || metadata.publicAddress.toLowerCase() !== ((_a = wallet.address) === null || _a === void 0 ? void 0 : _a.toLowerCase()))) return [3 /*break*/, 4];
                        loginRequired = true;
                        return [4 /*yield*/, magic.user.logout()];
                    case 3:
                        _b.sent();
                        _b.label = 4;
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        loginRequired = true;
                        _b.label = 6;
                    case 6:
                        if (!loginRequired) return [3 /*break*/, 8];
                        return [4 /*yield*/, loginWithMagicLink(wallet.email)];
                    case 7:
                        _b.sent();
                        _b.label = 8;
                    case 8:
                        provider = new ethers.BrowserProvider(magic.rpcProvider);
                        return [4 /*yield*/, provider.getSigner()];
                    case 9:
                        ethSigner = _b.sent();
                        return [2 /*return*/, ethSigner];
                }
            });
        });
    }
    function getMetamakSigner(wallet) {
        return __awaiter(this, void 0, void 0, function () {
            var chainIdReq, provider, ethSigner;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!window.ethereum || !window.ethereum.isMetaMask) {
                            alert('MetaMask not installed');
                            throw new Error('MetaMask not installed');
                        }
                        return [4 /*yield*/, window.ethereum.request({ method: 'eth_chainId' })];
                    case 1:
                        chainIdReq = _a.sent();
                        if (chainIdReq !== ethValidChainId) {
                            alert('Invalid MetaMask network');
                            throw new Error('Invalid MetaMask network');
                        }
                        return [4 /*yield*/, window.ethereum.request({ method: 'eth_requestAccounts' })];
                    case 2:
                        _a.sent();
                        if (!window.ethereum.selectedAddress ||
                            window.ethereum.selectedAddress.toLowerCase() !== wallet.address.toLowerCase()) {
                            alert('Invalid selected MetaMask address');
                            throw new Error('Invalid selected MetaMask address');
                        }
                        provider = new ethers.BrowserProvider(window.ethereum);
                        return [4 /*yield*/, provider.getSigner()];
                    case 3:
                        ethSigner = _a.sent();
                        return [2 /*return*/, ethSigner];
                }
            });
        });
    }
    function getImxWalletConnection(wallet) {
        return __awaiter(this, void 0, void 0, function () {
            var ethSigner, _a, starkKeyMapStr, starkKeyMap, _b, _c, starkSigner;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = wallet.connectionType;
                        switch (_a) {
                            case WalletConnectionType.METAMASK: return [3 /*break*/, 1];
                            case WalletConnectionType.MAGIC_LINK: return [3 /*break*/, 3];
                            case WalletConnectionType.MPC: return [3 /*break*/, 5];
                        }
                        return [3 /*break*/, 7];
                    case 1: return [4 /*yield*/, getMetamakSigner(wallet)];
                    case 2:
                        ethSigner = _d.sent();
                        return [3 /*break*/, 8];
                    case 3: return [4 /*yield*/, getMagicLinkSigner(wallet)];
                    case 4:
                        ethSigner = _d.sent();
                        return [3 /*break*/, 8];
                    case 5: return [4 /*yield*/, getMagicLinkSigner({
                            connectionType: WalletConnectionType.MAGIC_LINK,
                            address: wallet.magicLinkWalletAddress,
                            email: wallet.email,
                        })];
                    case 6:
                        ethSigner = _d.sent();
                        return [3 /*break*/, 8];
                    case 7:
                        {
                            throw new Error("Invalid connectionType: ".concat(wallet.connectionType));
                        }
                        _d.label = 8;
                    case 8:
                        if (!ethSigner)
                            throw new Error('Failed to create signer');
                        starkKeyMapStr = localStorage.getItem(LOCAL_STORAGE_STARK_KEY_MAP);
                        starkKeyMap = starkKeyMapStr ? JSON.parse(starkKeyMapStr) : {};
                        if (!!starkKeyMap[wallet.address.toLowerCase()]) return [3 /*break*/, 10];
                        _b = starkKeyMap;
                        _c = wallet.address.toLowerCase();
                        return [4 /*yield*/, x.generateLegacyStarkPrivateKey(ethSigner)];
                    case 9:
                        _b[_c] = _d.sent();
                        _d.label = 10;
                    case 10:
                        localStorage.setItem(LOCAL_STORAGE_STARK_KEY_MAP, JSON.stringify(starkKeyMap));
                        starkSigner = x.createStarkSigner(starkKeyMap[wallet.address.toLowerCase()]);
                        return [2 /*return*/, { ethSigner: ethSigner, starkSigner: starkSigner }];
                }
            });
        });
    }
    function checkTransactionSuccess(transactionId) {
        return __awaiter(this, void 0, void 0, function () {
            var pending, transaction;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        pending = true;
                        _a.label = 1;
                    case 1: return [4 /*yield*/, gqlSdk.MpcWalletTransactionFindOne({
                            input: { mpcWalletTransactionUuid: transactionId },
                        })];
                    case 2:
                        transaction = _a.sent();
                        if (!(transaction.mpcWalletTransactionFindOne.status === MpcWalletTransactionStatus.FAILED)) return [3 /*break*/, 3];
                        console.log('transaction.mpcWalletTransactionFindOne.error', transaction.mpcWalletTransactionFindOne.error);
                        pending = false;
                        throw new Error(transaction.mpcWalletTransactionFindOne.error || undefined);
                    case 3:
                        if (!(transaction.mpcWalletTransactionFindOne.status === MpcWalletTransactionStatus.COMPLETED)) return [3 /*break*/, 4];
                        pending = false;
                        return [3 /*break*/, 6];
                    case 4: return [4 /*yield*/, sleep(1000)];
                    case 5:
                        _a.sent();
                        _a.label = 6;
                    case 6:
                        if (pending === true) return [3 /*break*/, 1];
                        _a.label = 7;
                    case 7: return [2 /*return*/];
                }
            });
        });
    }
    function listForSale(input) {
        return __awaiter(this, void 0, void 0, function () {
            var walletFrom, sellTokenId, buyQuantity, buyTokenAddress, walletConnection, plainPrivateKeyShare1, imxProvider;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!fees)
                            return [2 /*return*/];
                        walletFrom = input.walletFrom, sellTokenId = input.sellTokenId, buyQuantity = input.buyQuantity, buyTokenAddress = input.buyTokenAddress;
                        return [4 /*yield*/, getImxWalletConnection(walletFrom)];
                    case 1:
                        walletConnection = _a.sent();
                        if (!(walletFrom.connectionType === WalletConnectionType.MPC)) return [3 /*break*/, 4];
                        return [4 /*yield*/, getPlainPrivateKeyShare1(walletConnection)];
                    case 2:
                        plainPrivateKeyShare1 = _a.sent();
                        return [4 /*yield*/, gqlSdk.MpcWalletListForSale({
                                input: {
                                    plainPrivateKeyShare1: plainPrivateKeyShare1,
                                    buyAmount: buyQuantity,
                                    buyTokenAddress: buyTokenAddress,
                                    sellTokenAddress: appEnv.blockchain.collectionAddress,
                                    sellTokenId: sellTokenId,
                                },
                            })];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        imxProvider = new x.GenericIMXProvider(new x.ProviderConfiguration({ baseConfig: { environment: appEnv.blockchain.imxConfig } }), walletConnection.ethSigner, walletConnection.starkSigner);
                        return [2 /*return*/, imxProvider.createOrder({
                                buy: tokenAmountHelper(buyTokenAddress, buyQuantity),
                                sell: {
                                    type: 'ERC721',
                                    tokenAddress: appEnv.blockchain.collectionAddress,
                                    tokenId: sellTokenId,
                                },
                                fees: fees.seller > 0 ? [{ address: appEnv.blockchain.feeAddress, fee_percentage: fees.seller }] : [],
                            })];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
    function makeOffer(input) {
        return __awaiter(this, void 0, void 0, function () {
            var walletFrom, buyTokenId, sellQuantity, sellTokenAddress, walletConnection, plainPrivateKeyShare1, imxProvider;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!fees)
                            return [2 /*return*/];
                        walletFrom = input.walletFrom, buyTokenId = input.buyTokenId, sellQuantity = input.sellQuantity, sellTokenAddress = input.sellTokenAddress;
                        return [4 /*yield*/, getImxWalletConnection(walletFrom)];
                    case 1:
                        walletConnection = _a.sent();
                        if (!(walletFrom.connectionType === WalletConnectionType.MPC)) return [3 /*break*/, 4];
                        return [4 /*yield*/, getPlainPrivateKeyShare1(walletConnection)];
                    case 2:
                        plainPrivateKeyShare1 = _a.sent();
                        return [4 /*yield*/, gqlSdk.MpcWalletMakeOffer({
                                input: {
                                    plainPrivateKeyShare1: plainPrivateKeyShare1,
                                    buyTokenAddress: appEnv.blockchain.collectionAddress,
                                    buyTokenId: buyTokenId,
                                    sellAmount: sellQuantity,
                                    sellTokenAddress: sellTokenAddress,
                                },
                            })];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        imxProvider = new x.GenericIMXProvider(new x.ProviderConfiguration({ baseConfig: { environment: appEnv.blockchain.imxConfig } }), walletConnection.ethSigner, walletConnection.starkSigner);
                        return [2 /*return*/, imxProvider.createOrder({
                                buy: {
                                    type: 'ERC721',
                                    tokenAddress: appEnv.blockchain.collectionAddress,
                                    tokenId: buyTokenId,
                                },
                                sell: tokenAmountHelper(sellTokenAddress, sellQuantity),
                                fees: fees.buyer > 0 ? [{ address: appEnv.blockchain.feeAddress, fee_percentage: fees.buyer }] : [],
                            })];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
    function cancelOrder(input) {
        return __awaiter(this, void 0, void 0, function () {
            var walletFrom, orderId, walletConnection, plainPrivateKeyShare1, imxProvider;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        walletFrom = input.walletFrom, orderId = input.orderId;
                        return [4 /*yield*/, getImxWalletConnection(walletFrom)];
                    case 1:
                        walletConnection = _a.sent();
                        if (!(walletFrom.connectionType === WalletConnectionType.MPC)) return [3 /*break*/, 4];
                        return [4 /*yield*/, getPlainPrivateKeyShare1(walletConnection)];
                    case 2:
                        plainPrivateKeyShare1 = _a.sent();
                        return [4 /*yield*/, gqlSdk.MpcWalletCancelOrder({
                                input: {
                                    plainPrivateKeyShare1: plainPrivateKeyShare1,
                                    orderId: orderId,
                                },
                            })];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        imxProvider = new x.GenericIMXProvider(new x.ProviderConfiguration({ baseConfig: { environment: appEnv.blockchain.imxConfig } }), walletConnection.ethSigner, walletConnection.starkSigner);
                        return [2 /*return*/, imxProvider.cancelOrder({ order_id: orderId })];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
    function createTrade(input) {
        return __awaiter(this, void 0, void 0, function () {
            var walletFrom, orderId, walletConnection, plainPrivateKeyShare1, result, _err_1, imxProvider;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!fees)
                            return [2 /*return*/];
                        walletFrom = input.walletFrom, orderId = input.orderId;
                        return [4 /*yield*/, getImxWalletConnection(walletFrom)];
                    case 1:
                        walletConnection = _a.sent();
                        if (!(walletFrom.connectionType === WalletConnectionType.MPC)) return [3 /*break*/, 8];
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 6, , 7]);
                        return [4 /*yield*/, getPlainPrivateKeyShare1(walletConnection)];
                    case 3:
                        plainPrivateKeyShare1 = _a.sent();
                        return [4 /*yield*/, gqlSdk.MpcWalletCreateTrade({
                                input: {
                                    plainPrivateKeyShare1: plainPrivateKeyShare1,
                                    orderId: orderId,
                                },
                            })];
                    case 4:
                        result = _a.sent();
                        return [4 /*yield*/, checkTransactionSuccess(result.mpcWalletCreateTrade.transactionUuid)];
                    case 5:
                        _a.sent();
                        return [3 /*break*/, 7];
                    case 6:
                        _err_1 = _a.sent();
                        throw new Error();
                    case 7: return [3 /*break*/, 9];
                    case 8:
                        imxProvider = new x.GenericIMXProvider(new x.ProviderConfiguration({ baseConfig: { environment: appEnv.blockchain.imxConfig } }), walletConnection.ethSigner, walletConnection.starkSigner);
                        return [2 /*return*/, imxProvider.createTrade({
                                order_id: orderId,
                                user: walletFrom.address,
                                fees: fees.buyer > 0 ? [{ address: appEnv.blockchain.feeAddress, fee_percentage: fees.buyer }] : [],
                            })];
                    case 9: return [2 /*return*/];
                }
            });
        });
    }
    function transferERC721(input) {
        return __awaiter(this, void 0, void 0, function () {
            var walletFrom, toAddress, tokenIds, tokenAddress, walletConnection, plainPrivateKeyShare1, imxProvider;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        walletFrom = input.walletFrom, toAddress = input.toAddress, tokenIds = input.tokenIds, tokenAddress = input.tokenAddress;
                        return [4 /*yield*/, getImxWalletConnection(walletFrom)];
                    case 1:
                        walletConnection = _a.sent();
                        if (!(walletFrom.connectionType === WalletConnectionType.MPC)) return [3 /*break*/, 4];
                        return [4 /*yield*/, getPlainPrivateKeyShare1(walletConnection)];
                    case 2:
                        plainPrivateKeyShare1 = _a.sent();
                        return [4 /*yield*/, gqlSdk.mpcWalletTransferERC721({
                                input: {
                                    plainPrivateKeyShare1: plainPrivateKeyShare1,
                                    toWalletAddress: toAddress,
                                    tokenAddress: tokenAddress || appEnv.blockchain.collectionAddress,
                                    tokenIds: tokenIds,
                                },
                            })];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        imxProvider = new x.GenericIMXProvider(new x.ProviderConfiguration({ baseConfig: { environment: appEnv.blockchain.imxConfig } }), walletConnection.ethSigner, walletConnection.starkSigner);
                        return [2 /*return*/, imxProvider.batchNftTransfer(tokenIds.sort().map(function (tokenId) { return ({
                                type: 'ERC721',
                                receiver: toAddress,
                                tokenId: tokenId,
                                tokenAddress: tokenAddress || appEnv.blockchain.collectionAddress,
                            }); }))];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
    function transferERC20(input) {
        return __awaiter(this, void 0, void 0, function () {
            var walletFrom, toAddress, tokenAddress, quantity, walletConnection, plainPrivateKeyShare1, imxProvider, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        walletFrom = input.walletFrom, toAddress = input.toAddress, tokenAddress = input.tokenAddress, quantity = input.quantity;
                        return [4 /*yield*/, getImxWalletConnection(walletFrom)];
                    case 1:
                        walletConnection = _a.sent();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 7, , 8]);
                        if (!(walletFrom.connectionType === WalletConnectionType.MPC)) return [3 /*break*/, 5];
                        return [4 /*yield*/, getPlainPrivateKeyShare1(walletConnection)];
                    case 3:
                        plainPrivateKeyShare1 = _a.sent();
                        return [4 /*yield*/, gqlSdk.MpcWalletTransferERC20({
                                input: {
                                    plainPrivateKeyShare1: plainPrivateKeyShare1,
                                    toWalletAddress: toAddress,
                                    tokenAddress: tokenAddress,
                                    amount: quantity,
                                },
                            })];
                    case 4:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        imxProvider = new x.GenericIMXProvider(new x.ProviderConfiguration({ baseConfig: { environment: appEnv.blockchain.imxConfig } }), walletConnection.ethSigner, walletConnection.starkSigner);
                        return [2 /*return*/, imxProvider.transfer(__assign({ receiver: toAddress }, tokenAmountHelper(tokenAddress, quantity)))];
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        err_1 = _a.sent();
                        throw err_1;
                    case 8: return [2 /*return*/];
                }
            });
        });
    }
    function mpcTransferETH(input) {
        return __awaiter(this, void 0, void 0, function () {
            var walletFrom, toAddress, quantity, walletConnection, plainPrivateKeyShare1, response, initPendingTransferResponse, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        walletFrom = input.walletFrom, toAddress = input.toAddress, quantity = input.quantity;
                        return [4 /*yield*/, getImxWalletConnection(walletFrom)];
                    case 1:
                        walletConnection = _a.sent();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 7, , 8]);
                        return [4 /*yield*/, getPlainPrivateKeyShare1(walletConnection)];
                    case 3:
                        plainPrivateKeyShare1 = _a.sent();
                        return [4 /*yield*/, gqlSdk.mpcWalletL1TransferETH({
                                input: {
                                    plainPrivateKeyShare1: plainPrivateKeyShare1,
                                    toWalletAddress: toAddress,
                                    amount: quantity,
                                },
                            })];
                    case 4:
                        response = _a.sent();
                        if (!response) return [3 /*break*/, 6];
                        return [4 /*yield*/, initPendingTransfer(response.mpcWalletL1TransferETH.transactionUuid)];
                    case 5:
                        initPendingTransferResponse = _a.sent();
                        if (initPendingTransferResponse) {
                            return [2 /*return*/, initPendingTransferResponse];
                        }
                        _a.label = 6;
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        err_2 = _a.sent();
                        console.log(err_2, 'err');
                        throw err_2;
                    case 8: return [2 /*return*/];
                }
            });
        });
    }
    function mpcTransferERC20(input) {
        return __awaiter(this, void 0, void 0, function () {
            var walletFrom, toAddress, tokenAddress, quantity, walletConnection, plainPrivateKeyShare1, response, initPendingTransferResponse, err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        walletFrom = input.walletFrom, toAddress = input.toAddress, tokenAddress = input.tokenAddress, quantity = input.quantity;
                        return [4 /*yield*/, getImxWalletConnection(walletFrom)];
                    case 1:
                        walletConnection = _a.sent();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 7, , 8]);
                        return [4 /*yield*/, getPlainPrivateKeyShare1(walletConnection)];
                    case 3:
                        plainPrivateKeyShare1 = _a.sent();
                        return [4 /*yield*/, gqlSdk.MpcWalletL1TransferERC20({
                                input: {
                                    plainPrivateKeyShare1: plainPrivateKeyShare1,
                                    toWalletAddress: toAddress,
                                    tokenAddress: tokenAddress,
                                    amount: quantity,
                                },
                            })];
                    case 4:
                        response = _a.sent();
                        if (!response) return [3 /*break*/, 6];
                        return [4 /*yield*/, initPendingTransfer(response.mpcWalletL1TransferERC20.transactionUuid)];
                    case 5:
                        initPendingTransferResponse = _a.sent();
                        if (initPendingTransferResponse) {
                            return [2 /*return*/, initPendingTransferResponse];
                        }
                        _a.label = 6;
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        err_3 = _a.sent();
                        console.log(err_3, 'err');
                        throw err_3;
                    case 8: return [2 /*return*/];
                }
            });
        });
    }
    function register(wallet) {
        return __awaiter(this, void 0, void 0, function () {
            var walletConnection, imxProvider;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getImxWalletConnection(wallet)];
                    case 1:
                        walletConnection = _a.sent();
                        imxProvider = new x.GenericIMXProvider(new x.ProviderConfiguration({ baseConfig: { environment: appEnv.blockchain.imxConfig } }), walletConnection.ethSigner, walletConnection.starkSigner);
                        return [2 /*return*/, imxProvider.registerOffchain()];
                }
            });
        });
    }
    function getPlainPrivateKeyShare1(walletConnection) {
        return __awaiter(this, void 0, void 0, function () {
            var symmetricKeyForDecryption, plainPrivateKeyShare1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!user)
                            throw new Error('[getPlainPrivateKeyShare1] User should not be null');
                        if (!user.mpcWalletCypherPrivateKeyShare1 ||
                            !user.mpcWalletCypherPrivateKeyShare1DKMsg ||
                            !user.mpcWalletCypherPrivateKeyShare1Iv ||
                            !user.mpcWalletCypherPrivateKeyShare1Tag)
                            throw new Error('[getPlainPrivateKeyShare1] User should have a mpcWalletCypherPrivateKeyShare1');
                        return [4 /*yield*/, deriveSymmetricKey(walletConnection.ethSigner, user.mpcWalletCypherPrivateKeyShare1DKMsg)];
                    case 1:
                        symmetricKeyForDecryption = _a.sent();
                        plainPrivateKeyShare1 = decryptString(symmetricKeyForDecryption, user.mpcWalletCypherPrivateKeyShare1, user.mpcWalletCypherPrivateKeyShare1Iv, user.mpcWalletCypherPrivateKeyShare1Tag);
                        return [2 /*return*/, plainPrivateKeyShare1];
                }
            });
        });
    }
    function strFloatToTokenQuantity(strFloat, decimals) {
        var splitted = strFloat.split('.');
        var _decimals = splitted[1]
            ? splitted[1].slice(0, parseInt(decimals)).padEnd(parseInt(decimals), '0')
            : ''.padEnd(parseInt(decimals), '0');
        return splitted[0] + _decimals;
    }
    function isAddressInitOnImx(ethAddress) {
        return __awaiter(this, void 0, Promise, function () {
            var user_1, _err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, imxClient.getUser(ethAddress)];
                    case 1:
                        user_1 = _a.sent();
                        if (user_1) {
                            return [2 /*return*/, true];
                        }
                        else
                            return [2 /*return*/, false];
                        return [3 /*break*/, 3];
                    case 2:
                        _err_2 = _a.sent();
                        return [2 /*return*/, false];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    return {
        imxClient: imxClient,
        listForSale: listForSale,
        createTrade: createTrade,
        makeOffer: makeOffer,
        cancelOrder: cancelOrder,
        transferERC721: transferERC721,
        transferERC20: transferERC20,
        register: register,
        strFloatToTokenQuantity: strFloatToTokenQuantity,
        mpcTransferETH: mpcTransferETH,
        mpcTransferERC20: mpcTransferERC20,
        isAddressInitOnImx: isAddressInitOnImx,
    };
}
